export interface Currency {
  code: string;
  label: string;
}

export const CURRENCIES: Currency[] = [
  { code: 'GBP', label: '£ British Pound (GBP)' },
  { code: 'USD', label: '$ US Dollar (USD)' },
  { code: 'EUR', label: '€ Euro (EUR)' },
];
